// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"fb38648f","198":"c9b2b592","496":"377c479a","703":"5a9d7ba5"}[chunkId] + ".chunk.js";
};